import React, { useEffect, useState } from 'react';
import ToastCreator from "./ToastCreator.jsx";

export default function UndoableItem({ item, getItemId, itemHasChangeThatCanBeUndone, undoButtonClicked, canUndoContent, afterClickedUndoContent }) {

	const [activeToasts, updateActiveToasts] = useState({});
	const [activeToastList, updateActiveToastList] = useState([]);

	function updateToastListFromMap(toasts) {
		const list = [];
		for(let toastKey in toasts) {
			const toast = toasts[toastKey];
			list.push(toast);
		}
		updateActiveToasts(toasts);
		updateActiveToastList(list);
	}

	function toastDismissed(plaidTransactionId) {
		const toasts = { ...activeToasts };
		console.log('should dismiss', plaidTransactionId);
		delete toasts[plaidTransactionId];
		updateToastListFromMap(toasts);
	}

	useEffect(() => {
		const activeToastsCopy = { ...activeToasts };
		if(!item) {
			return;
		}
		if(!activeToastsCopy[getItemId(item)]) {
			if(itemHasChangeThatCanBeUndone(item)) {
				activeToastsCopy[getItemId(item)] = {
					item,
					action: {
						content: 'Undo',
						onClick: () => {
							undoButtonClicked(item);
						},
						afterClickContent: afterClickedUndoContent(item),
					}
				};
				updateToastListFromMap(activeToastsCopy);
				return;
			}
			else {
			}
		}
	}, [item]);


	return (
		<React.Fragment>
			{activeToastList.map(({ item, action }) => (
				<ToastCreator
					onDismiss={toastDismissed.bind(null, getItemId(item))}
					key={getItemId(item)}
					action={action}
				>
					{canUndoContent(item)}
				</ToastCreator>
			))}
		</React.Fragment>
	);
}